import React from 'react';

import { ReactComponent as ChatIcon } from '../../images/chat.svg';
import { ReactComponent as ChevronRightIcon } from '../../images/chevron-right.svg';
import { loadLocalUser } from "../Services/HWIframeBridge";
import { s360ConfigService } from '../Services/S360Config';

import "../LandingPage/LandingPageStyleSheet.css";

function NewConversationButton(props) {
  const startConversation = () => {
    loadLocalUser()
    props.landingPageActions.checkAndStartNewConversationCometd(props.activeSession);
  };

  return (
    <div>
      <div className="s360-new-conversation-tab" style={props.config?.customDesign?.newConversationTab}>
        <div
          className="s360-new-conversation-tab-text"
          style={props.config?.customDesign?.chatTranscriptInitialFormStartButton}
          onClick={props?.page === "channels" ? props.onStartChanelClick : startConversation}
        >
          <div>
            <ChatIcon fill={s360ConfigService.config?.configDetails?.primaryColor} />
            <div>{props?.page === "channels" ? props?.buttonText : props.config?.configDetails?.startChatText}</div>
          </div>
          <ChevronRightIcon />
        </div>
      </div>
    </div>
  );
}
export default NewConversationButton;
